module.exports = __webpack_public_path__ + "img/draw_bonus3.a82f3863.png";